import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Select, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const { Option } = Select;
const HKUST_35_LOGO_URL =
    'https://surreality-1419044809.cos.ap-hongkong.myqcloud.com/photos/Standard%2035A%20Logo%20-%20FC%20%28W%29%20Bilingual%20Traditional%20Chinese.png';
const HKUST_GZ_LOGO_URL =
    'https://surreality-1419044809.cos.ap-hongkong.myqcloud.com/photos/USTGZ.png';

/**
 * 顶部导航栏
 */
export default function Header({ lang, onLangChange }) {
    const nav = useNavigate();
    const location = useLocation();
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const isLegacyRoute = location.pathname.startsWith('/surreality-1-0');
    const routeFor = (path) => {
        if (!isLegacyRoute) return path;
        return path === '/' ? '/surreality-1-0' : `/surreality-1-0${path}`;
    };

    /* ---------- 三语菜单 ---------- */
    const menuItems = {
        en: [
            { key: routeFor('/'),        label: 'Home'         },
            { key: routeFor('/info'),    label: 'Information'  },
            ...(!isLegacyRoute ? [{ key: '/agenda', label: 'Agenda' }] : []),
            { key: routeFor('/about'),   label: 'About Us'     },
            { key: routeFor('/contact'), label: 'Contact'      },
        ],
        'zh-Hans': [
            { key: routeFor('/'),        label: '首页'       },
            { key: routeFor('/info'),    label: '展览信息'   },
            ...(!isLegacyRoute ? [{ key: '/agenda', label: '日程' }] : []),
            { key: routeFor('/about'),   label: '关于我们'   },
            { key: routeFor('/contact'), label: '联系我们'   },
        ],
        'zh-Hant': [
            { key: routeFor('/'),        label: '首頁'       },
            { key: routeFor('/info'),    label: '展覽資訊'   },
            ...(!isLegacyRoute ? [{ key: '/agenda', label: '日程' }] : []),
            { key: routeFor('/about'),   label: '關於我們'   },
            { key: routeFor('/contact'), label: '聯絡我們'   },
        ],
    };

    /* ---------- 统一渲染函数 ---------- */
    const renderLinks = (isDrawer = false) =>
        menuItems[lang].map(({ key, label }) => (
            <li
                key={key}
                className={isDrawer ? '' : 'nav__link'}
                style={isDrawer ? { cursor: 'pointer' } : {}}
                onClick={() => {
                    nav(key);          // 跳转路由
                    if (isDrawer) setDrawerOpen(false);
                }}
            >
                <span
                    style={{
                        color: '#ffffff', /* 始终保持白色字体 */
                        fontWeight: 'bold', /* 加粗字体 */
                        fontSize: isDrawer ? '1.5rem' : '1rem', /* 调整字体大小 */
                    }}
                >
                    {label}
                </span>
            </li>
        ));

    return (
        <>
            {/* ===== 顶部条 ===== */}
            <div className="major-nav">
                {/* 科大 35 周年 Logo 需置于广州 Logo 之前 */}
                <nav className="nav-logo">
                    <img
                        src={HKUST_35_LOGO_URL}
                        alt="HKUST 35th Anniversary"
                    />
                    <div className="vertical" />
                    <img
                        src={HKUST_GZ_LOGO_URL}
                        alt="HKUST GZ"
                    />
                </nav>

                {/* 桌面导航 */}
                <nav className="nav">
                    <ul className="nav__links">
                        {renderLinks()}
                        <li className="nav__link">
                            <Select
                                className="language-select"
                                value={lang}
                                variant="borderless"
                                onChange={onLangChange}
                                popupMatchSelectWidth={false}
                                style={{
                                    color: '#ffffff', /* 确保语言选择文字为白色 */
                                    fontSize: '1.1rem', /* 增大字体大小 */
                                }}
                            >
                                <Option value="en">English</Option>
                                <Option value="zh-Hans">简体中文</Option>
                                <Option value="zh-Hant">繁體中文</Option>
                            </Select>
                        </li>
                    </ul>
                </nav>

                {/* 移动端汉堡按钮 */}
                <button
                    className="mobile-menu-btn"
                    onClick={() => setDrawerOpen(true)}
                    aria-label="Menu"
                    style={{
                        color: '#ffffff',
                        fontSize: '2.5rem',  /* 增大字体 */
                        padding: '1rem',     /* 增加点击区域 */
                    }}
                >
                    <MenuOutlined />
                </button>
            </div>

            {/* ===== Drawer（移动端侧边栏） ===== */}
            <Drawer
                placement="right"
                closable
                onClose={() => setDrawerOpen(false)}
                open={drawerOpen}
                styles={{
                    body: { background: '#1f2029', padding: '1.2rem' },
                    header: { display: 'none' },
                }}
            >
                <ul style={{ /* 不变 */ }}>
                    {renderLinks(true)}
                    <li style={{ marginTop: '1rem' }}>
                        <Select
                            className="language-select"
                            value={lang}
                            onChange={(v) => {
                                onLangChange(v);
                                setDrawerOpen(false);
                            }}
                            style={{
                                color: '#ffffff',    // 控制已选中的文字颜色
                                fontSize: '1.5rem',  // 字体大小
                            }}
                            dropdownStyle={{
                                backgroundColor: '#1f2029',  // 控制下拉框的背景颜色
                                color: '#ffffff',    // 控制下拉框内文字颜色
                            }}
                            dropdownClassName="language-select-dropdown" // 加入类名
                        >
                            <Option value="en">English</Option>
                            <Option value="zh-Hans">简体中文</Option>
                            <Option value="zh-Hant">繁體中文</Option>
                        </Select>



                    </li>
                </ul>
            </Drawer>
        </>
    );
}
